import type {PanelEntryContext} from './types';

export interface CommandSearchProviderConfig {
    category: string;
    supersedes?: string[];
    enabled?: (ctx: PanelEntryContext) => boolean;
}

/** Provider-level config not tied to individual entries. */
export const COMMAND_SEARCH_PROVIDER_CONFIG: Record<string, CommandSearchProviderConfig> = {
    'navigation-general': {
        category: 'pages',
        enabled: (ctx) => ctx.scope.stack.length === 0,
    },
    'navigation-customer': {
        category: 'pages',
        supersedes: ['navigation-general'],
        enabled: (ctx) => ctx.scope.stack.some((frame) => frame.type === 'customer'),
    },
    'navigation-vendor': {
        category: 'pages',
        supersedes: ['navigation-general'],
        enabled: (ctx) => ctx.scope.stack.some((frame) => frame.type === 'vendor'),
    },
    'panel-actions': {
        category: 'actions',
    },
};
